module.exports = __webpack_public_path__ + "2f195cba87ba641674f00da12d014bd1.MP3";